// 장례식장 카드 요약 배지 유틸.
//
// ⚠️ 비용(예상 견적)은 의도적으로 노출하지 않는다.
// 장례식장 입장에서 "왜 우리 비용을 함부로 까서 비교하냐"는 항의가 들어올 수 있어,
// 요약은 거리, 운영유형, 편의시설 등 사실 정보로만 구성한다.

/** 운영 유형 라벨. "전문"은 사설 다수라 '사설'로 표기. */
export function toTypeLabel(managedType?: string): string | null {
  if (!managedType) return null;
  return managedType === "전문" ? "사설" : managedType;
}

/**
 * 카드 요약 배지. 최대 4개.
 * 순서: 운영유형 → 거리 → 주차 → 식당 → 빈소수 → 지하철.
 * 비용은 넣지 않는다(파일 상단 주석 참고).
 */
export function buildCompareBadges(candidate: {
  distanceKm?: string;
  distance?: string;
  managedType?: string;
  hasParking?: boolean;
  hasMeal?: boolean;
  binsoCount?: number;
  hasTransit?: boolean;
}): string[] {
  const badges: string[] = [];
  const typeLabel = toTypeLabel(candidate.managedType);
  if (typeLabel) badges.push(typeLabel);
  const distance = candidate.distanceKm ?? candidate.distance;
  if (distance) badges.push(`${distance}km`);
  if (candidate.hasParking) badges.push("주차");
  if (candidate.hasMeal) badges.push("식당");
  if (candidate.binsoCount) badges.push(`빈소${candidate.binsoCount}`);
  if (candidate.hasTransit) badges.push("지하철");
  return badges.slice(0, 4);
}
